import { call, put, takeLatest } from 'redux-saga/effects';

import { userApi } from '../../../api';

import * as actions from './actions';

function* getBillingInfo() {
  try {
    yield put({ type: actions.GET_BILLING_INFO_PENDING });
    const { data } = yield call(userApi.getBillingInfo);
    const payload = { ...data };
    yield put({ type: actions.GET_BILLING_INFO_FULFILLED, payload });
  } catch (e) {
    yield put({ type: actions.GET_BILLING_INFO_REJECTED, payload: e });
  }
}

export function* watchGetBillingInfo() {
  yield takeLatest(actions.GET_BILLING_INFO, getBillingInfo);
}
